import { render, staticRenderFns } from "./Datas.vue?vue&type=template&id=68c5173a&scoped=true&"
import script from "./Datas.vue?vue&type=script&lang=js&"
export * from "./Datas.vue?vue&type=script&lang=js&"
import style0 from "./datas.scss?vue&type=style&index=0&id=68c5173a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c5173a",
  null
  
)

export default component.exports